'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSubComponentStyles = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _margin = require('understyle/dist/margin');

var _padding = require('understyle/dist/padding');

var _getTypographicStyle = require('./util/get-typographic-style');

var _getTypographicStyle2 = _interopRequireDefault(_getTypographicStyle);

var _radii = require('./util/radii');

var _radii2 = _interopRequireDefault(_radii);

var _colorStyle = require('./util/color-style');

var _colorStyle2 = _interopRequireDefault(_colorStyle);

var _getColorFill = require('./util/get-color-fill');

var _getColorFill2 = _interopRequireDefault(_getColorFill);

var _basic = require('./themes/basic');

var _basic2 = _interopRequireDefault(_basic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var isObj = function isObj(o) {
  return (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' && o !== null;
};

var getSubComponentStyles = exports.getSubComponentStyles = function getSubComponentStyles() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var keys = args.reduce(function (a, obj) {
    return [].concat(_toConsumableArray(a), _toConsumableArray(Object.keys(obj)));
  }, []).reduce(function (a, key) {
    var hasObj = args.reduce(function (acc, b) {
      return acc || isObj(b[key]);
    }, false);
    if (!hasObj) {
      return a;
    }
    if (a.indexOf(key) < 0) {
      a.push(key);
    }
    return a;
  }, []);

  return keys.reduce(function (a, key) {
    args.forEach(function (obj) {
      if (isObj(obj[key])) {
        a[key] = _extends({}, a[key], obj[key]);
      }
    });
    return a;
  }, {});
};

var withRebass = function withRebass(Comp) {
  var RebassBase = function (_React$Component) {
    _inherits(RebassBase, _React$Component);

    function RebassBase() {
      _classCallCheck(this, RebassBase);

      return _possibleConstructorReturn(this, (RebassBase.__proto__ || Object.getPrototypeOf(RebassBase)).apply(this, arguments));
    }

    _createClass(RebassBase, [{
      key: 'render',
      value: function render() {
        var rebass = this.context.rebass;
        var _props = this.props;
        var bold = _props.bold;
        var center = _props.center;
        var caps = _props.caps;
        var p = _props.p;
        var pt = _props.pt;
        var pr = _props.pr;
        var pb = _props.pb;
        var pl = _props.pl;
        var px = _props.px;
        var py = _props.py;
        var m = _props.m;
        var mt = _props.mt;
        var mr = _props.mr;
        var mb = _props.mb;
        var ml = _props.ml;
        var mx = _props.mx;
        var my = _props.my;
        var rounded = _props.rounded;
        var pill = _props.pill;
        var circle = _props.circle;
        var color = _props.color;
        var backgroundColor = _props.backgroundColor;
        var theme = _props.theme;
        var _props$style = _props.style;
        var style = _props$style === undefined ? {} : _props$style;

        var props = _objectWithoutProperties(_props, ['bold', 'center', 'caps', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'm', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'rounded', 'pill', 'circle', 'color', 'backgroundColor', 'theme', 'style']);

        var baseTheme = _extends({}, _basic2.default, rebass);
        var scale = baseTheme.scale;
        var colors = baseTheme.colors;
        var borderRadius = baseTheme.borderRadius;


        var themeStyle = baseTheme[Comp._name] || {};

        var margin = (0, _margin.setScale)(scale);
        var padding = (0, _padding.setScale)(scale);
        var radiusStyles = (0, _radii2.default)(borderRadius);
        var colorStyles = (0, _colorStyle2.default)(colors);

        var subComponentStyles = getSubComponentStyles(themeStyle, style);

        var sx = _extends({
          boxSizing: 'border-box'
        }, themeStyle, (0, _getTypographicStyle2.default)(baseTheme)({ bold: bold, center: center, caps: caps }), margin({ m: m, mt: mt, mr: mr, mb: mb, ml: ml, mx: mx, my: my }), padding({ p: p, pt: pt, pr: pr, pb: pb, pl: pl, px: px, py: py }), colorStyles({
          color: color,
          backgroundColor: backgroundColor
        }), radiusStyles({
          rounded: rounded,
          pill: pill,
          circle: circle
        }), style, {
          fill: theme ? (0, _getColorFill2.default)(colors)(theme) : {}
        });

        return _react2.default.createElement(Comp, _extends({}, props, {
          theme: baseTheme,
          subComponentStyles: subComponentStyles,
          style: sx
        }));
      }
    }]);

    return RebassBase;
  }(_react2.default.Component);

  RebassBase.contextTypes = {
    rebass: _react2.default.PropTypes.object
  };

  RebassBase.propTypes = {
    /** Sets foreground color */
    color: _react2.default.PropTypes.string,
    /** Sets background color */
    backgroundColor: _react2.default.PropTypes.string,
    /** Sets semantic color themes */
    theme: _react2.default.PropTypes.oneOf(['primary', 'secondary', 'default', 'info', 'success', 'warning', 'error', 'muted'])
  };

  RebassBase.displayName = Comp._name;

  return RebassBase;
};

exports.default = withRebass;


//////////////////
// WEBPACK FOOTER
// ./~/rebass/dist/withRebass.js
// module id = WQDq
// module chunks = 1